export var Frequency;
(function (Frequency) {
    Frequency["Daily"] = "DAILY";
    Frequency["WeeklyOnDay"] = "WEEKLY_ON_DAY";
    Frequency["MonthlyOnFirstWeekday"] = "FIRST";
    Frequency["MonthlyOnSecondWeekday"] = "SECOND";
    Frequency["MonthlyOnThirdWeekday"] = "THIRD";
    Frequency["MonthlyOnFourthWeekday"] = "FOURTH";
    Frequency["MonthlyOnLastWeekday"] = "LAST";
    Frequency["Weekday"] = "WEEKDAY";
    Frequency["Custom"] = "CUSTOM";
})(Frequency || (Frequency = {}));
